<template>
  <el-row class="fs-site fs-order-history">
    <el-row class="fs-entry-header">
      <el-col :span="4" class="fs-close">
        <a @click="back_page"><i class="el-icon-back"></i></a>
      </el-col>
      <el-col :span="16" class="text-center">
        <h1 class="text-title--large">{{ $t('pageOrderHistory.myorder') }}</h1>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="activeTabs" class="overide-tabs">
        <el-tab-pane :label="$t('without.text5')" name="current" v-if="OrderUpcoming.length > 0">
          <el-row class="mb-2" v-for="(item, index) in OrderUpcoming" :key="index">
            <OrderListCurrent
              :restaurant_uuid="restaurant_uuid"
              :branch_uuid="branch_uuid"
              :upcominglist="item"
              :index="index"
              @toggle_all_image="toggle_all_image"
              @toggle_bank_account_detail="toggle_bank_account_detail"
              @toggle_confirm_from_list_order="toggle_confirm_from_list_order"
            />
            <!-- <div class='fs-wave'></div> -->
          </el-row>
          <el-row>
            <el-col>
              <fullButton v-if="LoadMoreUpcoming" :handleClick="moreOrderUpcoming" :btn_text="$t('pageOrderHistory.showmore')" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('without.text5')" name="current" v-else>
          <el-row class="fs-list-none text-center mb-2">
            <el-col>
              <img width="100" src="@/assets/icons/empty-order.png">
            </el-col>
            <el-col>
              <h2 class="text-title--large my--3">{{ $t('pageOrderHistory.text1') }}</h2>
            </el-col>
            <el-col>
              <label class="text-heading3" v-html="$t('pageOrderHistory.text2')"></label>
              <!-- <label>เลือกสั่งตามเมนูที่คุณโปรดปราน</label><br>
              <label>ได้เลยนะคะ</label> -->
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('pageOrderHistory.history')" name="history" v-if="OrderHistory.length > 0">
          <el-row class="mb-2" v-for="(item, index) in OrderHistory" :key="index">
            <OrderListHistory
              :historylist="item"
              @toggle_all_image="toggle_all_image"
              @toggle_piad="toggle_piad"
            />
            <!-- <div class='fs-wave'></div> -->
          </el-row>
          <el-row>
            <el-col>
              <fullButton v-if="LoadMoreHistory" :handleClick="moreOrderHistory" :btn_text="$t('pageOrderHistory.showmore')" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('pageOrderHistory.history')" name="history" v-else>
          <el-row class="fs-list-none text-center mb-2">
            <el-col>
              <img width="100" src="@/assets/icons/empty-order.png">
            </el-col>
            <el-col>
              <h2 class="text-title--large my--3">{{ $t('pageOrderHistory.text1') }}</h2>
            </el-col>
            <el-col>
              <label class="text-heading3" v-html="$t('pageOrderHistory.text2')"></label>
              <!-- <label>เลือกสั่งตามเมนูที่คุณโปรดปราน</label><br>
              <label>ได้เลยนะคะ</label> -->
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <!-- Drawer More Image -->
    <OrderMoreImage v-if="is_open_image" :images="srcList" @toggle_all_image="toggle_all_image"/>
    <!-- Drawer Order Paid Detail -->
    <DrawerOrderPaidDetail v-if="is_open_piad" :historyitem="OrderHistoryItem" @toggle_piad="toggle_piad"/>
    <!-- Click Payment Drawer -->
    <el-drawer
      v-if="OrderUpcoming.length > 0 && type == 'upcoming' && OrderUpcoming[index].paymentType == 2"
      class="fs-credit-drawer"
      id="chanel-confirm"
      :visible.sync="isOpenDrawerBankDetail"
      :direction="'btt'"
      :size="'90%'"
      :with-header="false">
      <!-- Upload Slip Success -->
      <el-col v-if="isOpenDrawerUploadStatus">
        <el-row class="fs-site text-center" style="height: 80vh;">
          <el-col class="fs-content" style="
            margin: 0;
            position: absolute;
            top: 40%;
            left: 50%;
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          ">
            <img width="120" :src="require(`@/assets/icons/${ $i18n.locale == 'th' ? 'upload-sucess.jpg':'upload-success-en.png' }`)" /><br>
            <label class="text-title--large">{{ $t('pageOrderHistory.sendtransfer') }}</label><br>
            <label class="text-heading3 cl-gray-ligth-sec" v-html="$t('pageOrderHistory.branchreciveslip')"></label>
            <!-- <label class="fs-14 cl-gray-ligth-sec">ทางร้านได้รับหลักฐาน</label><br>
            <label class="fs-14 cl-gray-ligth-sec"> การชำระเงินแล้ว</label> -->
          </el-col>
          <el-col class="fs-credit-footer pb-0 fs-pos-ab">
            <fullButton :handleClick="closeUploadSlip" :btn_text="$t('pageMenuList.header.close')" />
          </el-col>
        </el-row>
      </el-col>
      <!-- Upload Slip -->
      <el-col v-else>
        <el-row class="fs-header">
          <el-col :span="10">
            <label class="text-title--large">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col :span="14" class="text-right">
            <label class="fs-link text-link" @click="redirectOrderDetail(OrderUpcoming[index].orderId)">{{ $t('pageOrderHistory.orderdetail') }}</label>
          </el-col>
        </el-row>
        <el-row class="fs-site mt-2" v-if="OrderUpcoming[index].paymentType == 2 && OrderUpcoming[index].payment">
          <el-col class="fs-content mb-5">
            <el-row>
              <el-col>
                <img class="fs-circle fs-al-sb" width="25" height="25" :src="'https://images.foodstory.co/'+ OrderUpcoming[index].payment[0].image_key">
                <label class="ml--2 text-heading3">{{ $t('drawer.editorder.transfer') }} {{ OrderUpcoming[index].payment[0].bank_name }}</label>
              </el-col>
            </el-row>
            <el-row class="fs-bd-b py--2">
              <el-col :span="16">
                <label class="text-heading3 cl-brown-ligth">{{ $t('pageCheckout.accountname') }}: {{ OrderUpcoming[index].payment[0].account_name }}</label><br>
                <label class="text-heading3 cl-brown-ligth">{{ $t('pageCheckout.accountnumber') }}: 
                  <em class="text-heading3--bold fs-st-n">{{ OrderUpcoming[index].payment[0].account_number }}</em>
                </label>
              </el-col>
              <el-col :span="8" class="text-right">
                <el-button plain @click="copyHandle(OrderUpcoming[index].payment[0].account_number)" class="copy-btn text-button">{{ $t('pageCheckout.copy') }}</el-button>
              </el-col>
            </el-row>
            <el-row class="fs-bd-b py-2">
              <el-col :span="12">
                <label class="text-title--large cl-brown-ligth">{{ $t('drawer.editorder.totalprice') }}</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label v-if="OrderUpcoming[index].isPaid == 0" class="text-title--large cl-brown-ligth">{{ OrderUpcoming[index].totalAmount | priceFormat(0,currency) }}</label>
                <label v-else class="text-title--large cl-brown-ligth">{{ OrderUpcoming[index].diffTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
             <el-row class="pt-4">
              <el-col v-bind:class="(DataFiles[index] == '' && LastedimageSlipURL[index] == '') ? 'fs-upload-border' : 'pa-0'" @click.native="dropImageSlip">
                <el-row v-if="DataFiles[index] == '' && LastedimageSlipURL[index] == ''">
                  <i class="fs-50 fs-link el-icon-upload"></i><br>
                  <label class="text-link fs-link">{{ $t('pageOrderHistory.sliptransfer') }}</label><br>
                  <label class="text-subtitle cl-brown-ligth">*{{ $t('pageOrderHistory.textsliptranfer1') }}</label><br>
                  <label class="text-subtitle cl-brown-ligth">{{ $t('pageOrderHistory.textsliptranfer2') }}</label>
                </el-row>
                <el-row>
                  <button 
                    v-if="OrderUpcoming[index].slipStatus || (LastedimageSlipURL[index] != '' && !OrderUpcoming[index].slipStatus) || (DataFiles[index] != '' && !OrderUpcoming[index].slipStatus)" 
                    class="text-button fs-edit-slip fs-border-none"
                  >
                    <i class="el-icon-edit"></i> 
                    {{ $t('pageOrderHistory.editimage') }}
                  </button>
                  <img id="previewSlip" class="fs-bd-r-12" :src="LastedimageSlipURL[index]" v-bind:class="OrderUpcoming[index].slipStatus || (LastedimageSlipURL[index] != '' && !OrderUpcoming[index].slipStatus) || (DataFiles[index] != '' && !OrderUpcoming[index].slipStatus) ? 'fs-w-100' : ''">
                </el-row>
              </el-col>
              <input
                id="imageSlip"
                type="file"
                style="display: none"
                ref="imageSlip"
                accept="image/*"
                v-on:change="previewFile($event)"
              >
            </el-row>
          </el-col>
          <el-col class="fs-stick fs-credit-footer pb-0 px-0">
            <fullButton class="text-button" @click.native="confirmUploadSlip(DataFiles[index])" :display="(DataFiles[index] == '') ? true : false" :btn_text="$t('pageOrderHistory.textuploadslip1')" />
          </el-col>
        </el-row>
      </el-col>
    </el-drawer>
    <!-- Auto Payment Drawer -->
    <el-drawer
      v-if="drawerData.length > 0 && type == 'history' && drawerData[index].paymentType == 2"
      class="fs-credit-drawer"
      id="chanel-confirm"
      :visible.sync="isOpenDrawerBankDetail"
      :direction="'btt'"
      :size="'90%'"
      :with-header="false">
      <!-- Upload Slip Success -->
      <el-col v-if="isOpenDrawerUploadStatus">
        <el-row class="fs-site text-center" style="height: 80vh;">
          <el-col class="fs-content" style="
            margin: 0;
            position: absolute;
            top: 40%;
            left: 50%;
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          ">
            <img width="120" :src="require(`@/assets/icons/${ $i18n.locale == 'th' ? 'upload-sucess.jpg':'upload-success-en.png' }`)" /><br>
            <label class="text-title--large">{{ $t('pageOrderHistory.sendtransfer') }}</label><br>
            <label class="text-heading3 cl-gray-ligth-sec" v-html="$t('pageOrderHistory.branchreciveslip')"></label>
            <!-- <label class="fs-14 cl-gray-ligth-sec">ทางร้านได้รับหลักฐาน</label><br>
            <label class="fs-14 cl-gray-ligth-sec"> การชำระเงินแล้ว</label> -->
          </el-col>
          <el-col class="fs-credit-footer pb-0 fs-pos-ab">
            <fullButton :handleClick="closeUploadSlip" :btn_text="$t('dialog.close')" />
          </el-col>
        </el-row>
      </el-col>
      <!-- Upload Slip -->
      <el-col v-else>
        <el-row class="fs-header">
          <el-col :span="10">
            <label class="text-heading2--bold">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col :span="14" class="text-right">
            <label class="fs-link text-heading3--med" @click="redirectOrderDetail(drawerData[index].orderId)">{{ $t('pageOrderHistory.orderdetail') }}</label>
          </el-col>
        </el-row>
        <el-row class="fs-site mt-2" v-if="drawerData[index].paymentType == 2 && drawerData[index].payment">
          <el-col class="fs-content mb-5">
            <el-row>
              <el-col>
                <img class="fs-circle fs-al-sb" width="25" height="25" :src="'https://images.foodstory.co/'+ drawerData[index].payment[0].image_key">
                <label class="text-subtitle">{{ $t('drawer.editorder.transfer') }} {{ drawerData[index].payment[0].bank_name }}</label>
              </el-col>
            </el-row>
            <el-row class="fs-bd-b pb-2">
              <el-col :span="16">
                <label class="text-subtitle cl-brown-ligth">{{ $t('pageCheckout.accountname') }}: {{ drawerData[index].payment[0].account_name }}</label><br>
                <label class="text-subtitle cl-brown-ligth">{{ $t('pageCheckout.accountnumber') }}: <em class="fw-lg fs-st-n">{{ drawerData[index].payment[0].account_number }}</em></label>
              </el-col>
              <el-col :span="8" class="text-right">
                <el-button plain @click="copyHandle(drawerData[index].payment[0].account_number)" class="copy-btn text-link">{{ $t('pageCheckout.copy') }}</el-button>
              </el-col>
            </el-row>
            <el-row class="fs-bd-b py-2">
              <el-col :span="12">
                <label class="text-heading2--bold cl-brown-ligth">ยอดชำระ</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label v-if="drawerData[index].isPaid == 0" class="text-title--large cl-brown-ligth">{{ drawerData[index].totalAmount | priceFormat(0,currency) }}</label>
                <label v-else class="text-title--large cl-brown-ligth">{{ drawerData[index].diffTotalAmount | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
             <el-row class="pt-4">
                <el-col v-bind:class="(DataFiles[index] == '' && LastedimageSlipURL[index] == '') ? 'fs-upload-border' : 'pa-0'" @click.native="dropImageSlip">
                  <el-row v-if="DataFiles[index] == '' && LastedimageSlipURL[index] == ''">
                    <i class="fs-50 fs-link el-icon-upload"></i><br>
                    <label class="text-heading2 fs-link">{{ $t('pageOrderHistory.sliptransfer') }}</label><br>
                    <label class="text-body cl-brown-ligth">*{{ $t('pageOrderHistory.textsliptranfer1') }}</label><br>
                    <label class="text-body cl-brown-ligth">{{ $t('pageOrderHistory.textsliptranfer2') }}</label>
                  </el-row>
                  <el-row>
                    <button
                    v-if="OrderUpcoming[index].slipStatus || (LastedimageSlipURL[index] != '' && !OrderUpcoming[index].slipStatus) || (DataFiles[index] != '' && !OrderUpcoming[index].slipStatus)"
                    class="text-heading3 fs-edit-slip fs-border-none">
                      <i class="el-icon-edit"></i> {{ $t('pageOrderHistory.editimage') }}
                    </button>
                    <img id="previewSlip" class="fs-bd-r-12" :src="LastedimageSlipURL[index]" v-bind:class="OrderUpcoming[index].slipStatus || (LastedimageSlipURL[index] != '' && !OrderUpcoming[index].slipStatus) || (DataFiles[index] != '' && !OrderUpcoming[index].slipStatus) ? 'fs-w-100' : ''">
                  </el-row>
                </el-col>
                <input
                  id="imageSlip"
                  type="file"
                  style="display: none"
                  ref="imageSlip"
                  accept="image/*"
                  v-on:change="previewFile($event)"
                >
              </el-row>
          </el-col>
          <el-col class="fs-stick fs-credit-footer pb-0 px-0">
            <fullButton @click.native="confirmUploadSlip(DataFiles[index])" :display="(DataFiles[index] == '') ? true : false" :btn_text="$t('pageOrderHistory.textuploadslip1')" />
          </el-col>
        </el-row>
      </el-col>
    </el-drawer>
    <!-- Dialog EditOrder -->
    <DrawerEditOrder
      v-if="isOpenDrawerEditOrder && activeTabs == 'current' && drawerData.length > 0"
      @toggle_edit_order="toggle_edit_order"
      @toggle_edit_order_transfer="toggle_edit_order_transfer"
      :status="status"
      :confirm="confirm"
      :page="'orderhistory'"
      :restaurant_uuid="restaurant_uuid"
      :branch_uuid="branch_uuid"
      :drawerData="drawerData[index]"
    />
  </el-row>
</template>
<script>
import fullButton from '@/components/element/fullButton'
import OrderListCurrent from './OrderListCurrent'
import OrderListHistory from './OrderListHistory'
import OrderMoreImage from './OrderMoreImage'
import DrawerOrderPaidDetail from './DrawerOrderPaidDetail'
import DrawerEditOrder from './DrawerEditOrder'
import Mixins from '@/utils/mixins'

export default {
  name: 'OrderHistory',
  props: ['restaurant_uuid', 'branch_uuid'],
  mixins: [Mixins],
  components: {
    fullButton,
    OrderListCurrent,
    OrderListHistory,
    OrderMoreImage,
    DrawerOrderPaidDetail,
    DrawerEditOrder
  },
  data () {
    return {
      paginate: 1,
      is_open_image: false,
      is_open_piad: false,
      activeTabs: 'current',
      OrderHistoryItem: [],
      srcList: [],
      LoadMoreHistory: false,
      LoadMoreUpcoming: false,
      isOpenDrawerBankDetail: false,
      isOpenDrawerEditOrder: false,
      confirm: false,
      status: true,
      drawerData: [],
      index: 0,
      type: 'history',
      isOpenDrawerUploadStatus: false,
      DataFiles: [],
      LastedimageSlipURL: [],
      currency: this.$store.getters.currency
    }
  },
  created () {
    this.isOpenDrawerEditOrder = false
    this.$store.dispatch('onAuthStateChanged').then((user) => {
      if (user) {
        this.$store.dispatch('getBadgeEditOrder', {
          restaurant_uuid: this.BranchDetail.restaurantId,
          branch_uuid: this.BranchDetail.id
        })
        this.$store.dispatch('getOrderHistory', {
          paginate: this.paginate * 25
        })
        this.$store.dispatch('getOrderUpcoming', {
          paginate: this.paginate * 25
        })
      }
    })
  },
  methods: {
    back_page () {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}` })
    },
    toggle_all_image (srcList) {
      this.srcList = srcList
      this.is_open_image = !this.is_open_image
    },
    toggle_piad (OrderHistoryItem) {
      this.OrderHistoryItem = OrderHistoryItem
      this.is_open_piad = !this.is_open_piad
    },
    toggle_edit_order (value) {
      this.isOpenDrawerEditOrder = !this.isOpenDrawerEditOrder
      if (value.status != 'hide') {
        this.$store.dispatch('getOrderUpcoming', { paginate: 25 })
      }
      if (value.status == 'hide' && value.orderDetail.editType == 2) {
        // console.log('dev2')
        this.$store.dispatch('setConfirmEditOrder', {
          restaurant_uuid: this.BranchDetail.restaurantId,
          branch_uuid: this.BranchDetail.id,
          orderId: value.orderDetail.orderId
        }).then((response) => {
          this.$store.dispatch('getOrderUpcoming', { paginate: 25 })
        })
      }
      // console.log(this.isOpenDrawerEditOrder)
    },
    toggle_edit_order_transfer (index) {
      this.isOpenDrawerBankDetail = !this.isOpenDrawerBankDetail
      if (!this.isOpenDrawerBankDetail) {
        this.$store.dispatch('getOrderUpcoming', { paginate: 25 })
      }
      this.isOpenDrawerUploadStatus = false
    },
    toggle_bank_account_detail (payload) {
      this.type = payload.type
      this.index = payload.index

      // Set Slip Image
      if (payload.upcoming.slipStatus) {
        this.DataFiles[this.index] = ''
        this.LastedimageSlipURL[this.index] = 'https://images.foodstory.co/' + payload.upcoming.slipImageKey
      }

      // Set Slip Image
      const preview = document.getElementById('previewSlip')
      if (preview !== null) {
        preview.src = (payload.upcoming.slipStatus) ? this.LastedimageSlipURL[this.index] : ''
        preview.style.width = ''
        preview.style.height = ''
      }

      this.isOpenDrawerBankDetail = !this.isOpenDrawerBankDetail

    },
    async toggle_confirm_from_list_order (value) {
      const loading = await this.$store.dispatch('startLoading')
      this.$store.dispatch('getOrderUpcoming', { paginate: 25 }).then((res) => {
        loading.close()
      })
    },
    async redirectOrderDetail (orderId) {
     await this.$store.dispatch('startLoading')
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/confirmorder`, query: { oid: orderId } })
    },
    async moreOrderHistory () {
      await this.$store.dispatch('startLoading')
      this.paginate = (this.paginate + 1) * 25
      this.$store.dispatch('getOrderHistory', {
        paginate: this.paginate
      })
    },
    async moreOrderUpcoming () {
      await this.$store.dispatch('startLoading')
      this.paginate = (this.paginate + 1) * 25
      this.$store.dispatch('getOrderUpcoming', { paginate: this.paginate })
    },
    groupOrderStatus (OrderUpcoming) {
      var result = _(OrderUpcoming)
      .groupBy('restaurantName')
      .map(function(item) {
        var obj = {}
        obj = _.countBy(item, 'deliveryStatus')
        return obj
      }).value()
      return result
    },
    findIndexOrderStatus (OrderUpcoming) {

      let arrEditOrder = []
      OrderUpcoming.forEach((element, index) => {

        this.DataFiles[index] = ''
        this.LastedimageSlipURL[index] = (element.slipStatus) ? 'https://images.foodstory.co/' + element.slipImageKey : ''

        if (element.deliveryStatus == 3 && element.confirmEditFlag == 0 ||
            element.deliveryStatus == 9 && element.editType != 1 && element.confirmEditFlag == 0 ||
            element.deliveryStatus == 2 && element.confirmEditFlag == 0 && element.editType == 2 ||
            element.deliveryStatus == 3 && element.paymentType == 2 && element.confirmEditFlag == 1)
        { // deliveryStatus = 3
          arrEditOrder.push(index)
        }
      })
      return arrEditOrder
    },
    copyHandle(str){
      const el = document.createElement('textarea');  // Create a <textarea> element
      el.value = str;                                 // Set its value to the string that you want copied
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.position = 'absolute';
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0)     // Store selection if found
          : false;                                    // Mark as false to know no selection existed before
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el);                  // Remove the <textarea> element
      if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected);
      }
      if (!this.isCopy) {
        this.$notify({
          title: this.$t('pageCheckout.copyaccount'),
          customClass: 'copy-notify',
          iconClass: 'copy-notification',
          duration: 4000,
          type: 'success',
          showClose: false
        });
        this.isCopy = true
        setTimeout(() => {
          this.isCopy = false
        }, 4000);
      }
    },
    closeUploadSlip () {
      this.isOpenDrawerBankDetail = false
    },
    dropImageSlip () {
      document.getElementById('imageSlip').value = ''
      this.$refs.imageSlip.click()
    },
    previewFile (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (files[0].size > 2097152) { // limit 2MB OR 2097152 Byte And JPEG OR PNG
        this.$notify({
          title: this.$t('pageOrderHistory.textsliptranfer1'),
          customClass: 'fs-notify fs-error-notify',
          iconClass: 'fs-notification',
          duration: 3000,
          type: 'warning',
          showClose: false
        })
      } else {
        if (files[0].type == 'image/jpeg' || files[0].type == 'image/jpg' || files[0].type == 'image/png') {
          // Set File Before Upload Pass
          this.DataFiles[this.index] = files[0]
          // Preview Image Before Upload
          this.setPreviewImage(this.DataFiles[this.index])
          // Force Preview Image Slip
          this.$forceUpdate()
        } else {
          this.$notify({
            title: this.$t('pageOrderHistory.textsliptranfer2'),
            customClass: 'fs-notify fs-error-notify',
            iconClass: 'fs-notification',
            duration: 3000,
            type: 'warning',
            showClose: false
          })
        }
      }
    },
    setPreviewImage (files) {
      const preview = document.getElementById('previewSlip')
      const reader = new FileReader();
      reader.addEventListener("load", function () {
        // convert image file to base64 string
        preview.src = reader.result
        // set w/h image file
        preview.style.width = "100%"
        preview.style.height = "100%"
      }, false);

      if (files) reader.readAsDataURL(files)
    },
    async confirmUploadSlip (file) {
      if(file === null) {
        this.$notify({
          title: this.$t('pageOrderHistory.textuploadslip2'),
          customClass: 'fs-notify fs-error-notify',
          iconClass: 'fs-notification',
          duration: 3000,
          type: 'error',
          showClose: false
        })
      } else {
        // Set Loading Upload Image
        const loading = await this.$store.dispatch('startLoading')
        // Set Body File
        var bodyFormData = new FormData()
        bodyFormData.set('image_slip', file)
        // Send API Confirm Upload Slip
        this.$store.dispatch('setConfirmUploadSlip', {
          orderId: this.OrderUpcoming[this.index].orderId,
          data: bodyFormData
        }).then((response) => {
          if(response) {
            loading.close()
            this.isOpenDrawerUploadStatus = true
          } else {
            loading.close()
            this.$notify({
              title: this.$t('pageOrderHistory.uploaderror'),
              customClass: 'fs-notify fs-error-notify',
              iconClass: 'fs-notification',
              duration: 3000,
              type: 'error',
              showClose: false
            })
          }
        })
      }
    }
  },
  computed: {
    OrderHistory () {
      let OrderHistory = this.$store.getters.OrderHistory
      this.LoadMoreHistory = (OrderHistory.length == 0) ? false : OrderHistory[0].LoadMore
      return OrderHistory
    },
    OrderUpcoming () {
      let OrderUpcoming = this.$store.getters.OrderUpcoming

      // Load More
      this.LoadMoreUpcoming = (OrderUpcoming.length == 0) ? false : OrderUpcoming[0].LoadMore

      return OrderUpcoming
    },
    BadgeEditOrder () {
      return this.$store.getters.BadgeEditOrder
    },
    BranchDetail () {
      return this.$store.getters.BranchDetail
    },
    confirmCol () {
      let contact_list = 0
      if (this.BranchDetail.fbMessenger) {
        contact_list++
      }
      if (this.BranchDetail.lineName) {
        contact_list++
      }
      return 24 / (contact_list || 1)
    }
  },
  watch: {
    BadgeEditOrder () {},
    isOpenDrawerBankDetail (value) {
      if (!value && this.isOpenDrawerUploadStatus || !value && !this.isOpenDrawerUploadStatus) {
        this.$store.dispatch('getOrderUpcoming', { paginate: 25 })
        this.isOpenDrawerBankDetail = false
        this.isOpenDrawerUploadStatus = false
        // console.log(this.LastedimageSlipURL[this.index])
      }
    },
    OrderUpcoming (upcoming) {
      if (upcoming.length > 0) {

        // Count Edit Order
        var group_order = this.groupOrderStatus(upcoming)
        var filter_order = this.findIndexOrderStatus(upcoming)

        this.drawerData = filter_order.map((value) => upcoming[value])

        // Open Drawer Confirm Edit Order
        this.confirm = false
        this.status = true

        this.isOpenDrawerEditOrder = (group_order[0][2] > 0 || group_order[0][3] > 0 || group_order[0][9]) ? true : false

      }
    },
    activeTabs (value) {
      if (value == 'current') {
        this.$store.dispatch('getOrderUpcoming', { paginate: 25 })
        this.isOpenDrawerBankDetail = false
        this.isOpenDrawerUploadStatus = false
      } else {
        this.$store.dispatch('getOrderHistory', { paginate: 25 })
      }
    }
  }

}

</script>

<style lang="scss" scoped>
.overide-tabs {
 /deep/ {
   .el-tabs__item {
     font-size: 22px;
   }
 }
}
</style>


// WEBPACK FOOTER //
// src/components/order/OrderHistory.vue